import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';
import { SnakeCasedProperties } from 'type-fest';

export const formatToSnakeCase = <T>(obj: T): SnakeCasedProperties<T> =>
  mapKeys(obj || {}, (_v, k) => snakeCase(k)) as SnakeCasedProperties<T>;
